// extracted by mini-css-extract-plugin
module.exports = {"error":"Textarea_error__2yVCA","textareaWrapper":"Textarea_textareaWrapper__1L4GI","label":"Textarea_label__1a1DU","textarea":"Textarea_textarea__37EsJ"};